<!-- src/components/UserAccount.vue -->
<template>
  <div class="user-account">
    <h1>{{ getSelectedCompany?.name || 'No Company Selected' }}</h1>
    <h3>Agent: {{ getSelectedUser?.name || 'Not selected or not logged in.' }}</h3>
    <h3 v-if="getSelectedUser?.bbasPhone">Agent Dial-In: {{ getSelectedUser.bbasPhone }}</h3>
    <h3 v-if="getSelectedUser?.agentDialinCode">Code: {{ getSelectedUser.agentDialinCode }}</h3>    
    <v-btn 
      class="clear-user" 
      @click="clearDialedInStatus"
      :disabled="!getSelectedUser">
      Clear Dialed-In Status
    </v-btn>
    <v-btn 
      class="clear-user" 
      @click="clearTalkingToStatus"
      :disabled="!getSelectedUser">
      Clear Talking To Status
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  computed: {
    ...mapGetters(['getSelectedUser', 'getSelectedCompany']),
  },
  methods: {
    async handleClearDialedInStatus() {
      try {
        if (!this.getSelectedUser?.uid) {
          await this.$showOkDialog(
            'Error',
            'No user found. Please log in again.'
          );
          return;
        }
        const updateUserObject = { isDialedIn: false };
        const response = await axios.put(
          `/portaldb/db/updateUserProperties/${this.getSelectedUser.uid}`, 
          updateUserObject
        );
        
        if (response.data.success) {
          await this.$showOkDialog(
            'Success',
            'Your dialed-in status has been cleared successfully.'
          );
        } else {
          await this.$showOkDialog(
            'Error',
            `Failed to clear dialed-in status: ${response.data.message}`
          );
        }
      } catch (error) {
        await this.$showOkDialog(
          'Error',
          `An error occurred while clearing dialed-in status: ${error.message}`
        );
      }
    },

    async clearDialedInStatus() {
      if (!this.getSelectedUser) {
        await this.$showOkDialog(
          'Error',
          'No user selected. Please log in first.'
        );
        return;
      }
      await this.$showOkDialog(
        '', 
        `Clear dialed-in status for agent ${this.getSelectedUser.name}?`,
        this.handleClearDialedInStatus
      );
    },

    async handleClearTalkingToStatus() {
      try {
        if (!this.getSelectedUser?.uid) {
          await this.$showOkDialog(
            'Error',
            'No user found. Please log in again.'
          );
          return;
        }
        const updateUserObject = { talkingTo: "" };
        const response = await axios.put(
          `/portaldb/db/updateUserProperties/${this.getSelectedUser.uid}`, 
          updateUserObject
        );
        
        if (response.data.success) {
          await this.$showOkDialog(
            'Success',
            'Your talking-to status has been cleared successfully.'
          );
        } else {
          await this.$showOkDialog(
            'Error',
            `Failed to clear talking-to status: ${response.data.message}`
          );
        }
      } catch (error) {
        await this.$showOkDialog(
          'Error',
          `An error occurred while clearing talking-to status: ${error.message}`
        );
      }
    },

    async clearTalkingToStatus() {
      if (!this.getSelectedUser) {
        await this.$showOkDialog(
          'Error',
          'No user selected. Please log in first.'
        );
        return;
      }
      await this.$showOkDialog(
        '', 
        `Clear talking-to status for agent ${this.getSelectedUser.name}?`,
        this.handleClearTalkingToStatus
      );
    }
  },
  mounted() {
    console.log('Selected user in UserAccount.vue:', this.getSelectedUser);
  },
};
</script>

<style scoped>
.clear-user {
  background-color: #d2b48c;
  margin-top: 15px;
  margin-right: 20px;
}
.user-account {
  margin-top: 20px;
  text-align: left;
}
h1 {
  font-size: 1.5em;
}
h3 {
  font-size: 1.0em;
  margin: 2px 0;
}
</style>
